import React from "react";
import { Container, Grid, Typography } from "@mui/material";
import SectionTitle from "../../utils/SectionTitle";

export default function Mission() {
  return (
    <div className="mission_section_main">
      <Container>
        <SectionTitle title={"our mission"} />
        <Grid container spacing={4} className="space_top">
          <Grid item xs={12} md={6} className="mission_content">
            <Typography variant="h3" className="heading_three" gutterBottom>
              Bringing transparency to prescription drug pricing.
            </Typography>
            <Typography variant="body1" className="description" gutterBottom>
              RXpose exists to help people better understand the true cost of prescription drugs in the United States.
              By comparing U.S. drug prices with those in other developed markets,
              our platform highlights the significant disparities that often exist
              for the same brand-name medications.
            </Typography>
            <Typography variant="body1" className="description" gutterBottom>
              Our mission is to make pricing information easier to see, easier to understand,
              and easier to share with policymakers and the public.
            </Typography>
            <Typography
              variant="body2"
              className="description"
              gutterBottom
              sx={{ fontStyle: "italic", mt: 2, color: "#82929b" }}
            >
              *We believe that transparency is the first step toward meaningful
              conversation and informed decision-making about the future of
              healthcare costs in America.*
            </Typography>
          </Grid>
          <Grid item xs={12} md={6}>
            <img
              src="/images/missiongirls.png"
              alt="RXpose Mission"
              style={{ width: "100%", height: "auto" }}
            />
          </Grid>
        </Grid>
      </Container>
    </div>
  );
}
